export type LogicalOperator = "And" | "Or" | "AndNot";
